<template>
  <component
    :is="iconComponent"
    class="svg-icon"
    :class="{ disabled }"
    :style="iconStyle"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import svgIconMap from './svgIconMap'

export interface SvgIconProps {
  is?: Component
  name?: string
  size?: number | string
  color?: string
  disabled?: boolean
}

const props = defineProps<SvgIconProps>()

const iconComponent = computed(() => {
  if (props.is) return props.is
  if (props.name) return svgIconMap[props.name]
  return null
})

const iconStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.size) {
    style.fontSize = typeof props.size === 'number' ? `${props.size}px` : props.size
  }
  if (props.color) {
    style.color = props.color
  }
  return style
})
</script>

<style lang="scss" scoped>
.svg-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 0;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
